import type { ConceptDef } from '../types';

export const imitateGrossMotor: ConceptDef = {
  kind: 'supervisorScored',
  id: 'imitate-gross-motor',
  label: 'Imitate Gross Motor',
  category: 'Motor imitation',
  description: 'Model a gross-motor action; learner imitates. Supervisor scores.',
  config: {
    promptMode: 'TEXT',
    prompts: [
      { prompt: 'Wave both arms.' },
      { prompt: 'Clap hands.' },
      { prompt: 'Stand and turn around.' },
      { prompt: 'Touch your toes.' },
      { prompt: 'Jump in place.' },
    ],
  },
};
